export default function keycloakReducer(keycloak = {}) {
  return keycloak;
}
